import { render, staticRenderFns } from "./QuestionEditTranslation.vue?vue&type=template&id=5f6aa6ee&"
import script from "./QuestionEditTranslation.vue?vue&type=script&lang=js&"
export * from "./QuestionEditTranslation.vue?vue&type=script&lang=js&"
import style0 from "./QuestionEditTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports